import { UpgradeModule } from '@angular/upgrade/static';
import { Injectable } from '@angular/core';
import { generated } from '../../environments/environment.generated';
import responseNg1 from '../../../old-crazy-web-frontend/src/app/api-config-response';

@Injectable()
export class ConfigService {
  public commitHash: string = generated.commitHash;
  public backendUrl = responseNg1.data.backend;

  constructor(private upgrade: UpgradeModule) {}

  public getValue(key: string) {
    if (this.upgrade.$injector) {
      return this.upgrade.$injector.get(key);
    } else {
      console.warn('$injector not yet initialized');
    }
  }
}
